import React from "react";
import { Box, styled } from "@mui/material";
import { FaCircleUser } from "react-icons/fa6";

type UserAvatarProps = {
  profileImage?: string;
  size?: number;
};

const StyledContainer = styled(Box)<{ size?: number }>(
  ({ theme, size = 40 }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    width: `${size}px`,
    height: `${size}px`,
    svg: {
      width: "90%",
      height: "90%",
      color: theme.palette.grey[500],
    },
  }),
);

const StyledImage = styled("img")(() => ({
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  objectFit: "cover",
}));

const UserAvatar: React.FC<UserAvatarProps> = ({ profileImage, size }) => {
  return (
    <StyledContainer size={size}>
      {profileImage ? (
        <StyledImage src={profileImage} alt="profile" />
      ) : (
        <FaCircleUser />
      )}
    </StyledContainer>
  );
};

export default UserAvatar;
